import {
    ExerciseDto,
    Question,
    Program,
    UpdateExerciseHandler,
} from './interfaces';
import { getExerciseData as getPresExerciseData } from './program-pres/exercises';
import { getExerciseData as getStressExerciseData } from './program-stress/exercises';
import { getExerciseData as getTankeExerciseData } from './program-tanke/exercises';

export type CustomLogbookViewProps = {
    exercise: ExerciseDto;
    className: string;
};

export type CloseConfirmationConfig = {
    title: string;
    body: string;
    confirmText: string;
    cancelText: string;
};

export type ExerciseData = {
    dataKeys: string[];
    questions: Question[];
    ExerciseView: (props: ExerciseViewProps) => React.ReactNode;
    LogbookHeader?: (props: CustomLogbookViewProps) => React.ReactNode;
    /// Checks if the ExerciseDto contains any data that should be shown by the LogbookHeader view.
    haveDataForLogbook?: (exercise: ExerciseDto) => boolean;
    closeConfirmation?: CloseConfirmationConfig;
};

export type ExerciseViewProps = {
    exercise: ExerciseDto;
    onContinue: UpdateExerciseHandler;
};

export function getExerciseData(program: Program, code: string): ExerciseData {
    switch (program) {
        case Program.Pres:
            return getPresExerciseData(code);
        case Program.Stress:
            return getStressExerciseData(code);
        case Program.Tanke:
            return getTankeExerciseData(code);
    }
}
